import { render, staticRenderFns } from "./sportsMarket.vue?vue&type=template&id=5084a3ce&lang=pug&"
import script from "./sportsMarket.vue?vue&type=script&lang=js&"
export * from "./sportsMarket.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports